module.exports = __webpack_public_path__ + "img/altaiyz-design.195fda5b.webp";